<template>
  <div :class="buttonClass" @click="handleClick">
    {{ text }}
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String
    },
    primary: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    },
    default: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    danger: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonClass () {
      return {
        'disabled': this.disabled,
        'primary': this.primary,
        'secondary': this.secondary,
        'default': this.default,
        'full-width': this.fullWidth,
        'danger': this.danger
      }
    }
  },
  methods: {
    handleClick (e) {
      if (!this.disabled) {
        this.$emit('click', e)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../css/var'

$normal-height = pt(80)
$border-radius = 3pt

buttton(bc, tc)
  line-height $normal-height
  height $normal-height
  font-size $big-font-size
  background bc
  color tc
  text-align center
  border-radius $border-radius

.primary
  buttton $primary-color $white-text-color

.secondary
  buttton $secondy-color $white-text-color

.default
  buttton #ffffff $normal-text-color
  border 1pt solid $normal-text-color

.disabled
  buttton #ffffff $disable-text-color
  border 1pt solid $disable-text-color

.danger
  buttton #E64340 $white-text-color

.full-width
  width  100%
</style>




// WEBPACK FOOTER //
// button.vue?6efb1e83